<div *ngIf="infoCard" class="card w-100 info-card" [class]="{'disabled': infoCard.disabled}" >
  <div class="card-body d-flex flex-column justify-content-between">
    <div class="nav-container">
      <div class="nav-container_header d-flex justify-content-between">
        <div class="text">
          <h3 class="card-title">{{infoCard.title  | translate }}</h3>
        </div>
        <div class="icon">
          <img [src]="'../../../assets/img/icons-svg/' + infoCard.icon + '.svg'"/>
        </div>
      </div>
      <ul class="nav nav-tabs mt-2" id="myTab" role="tablist">
        <li *ngFor="let info of infoCard.infos" class="nav-item">
          <a
            class="nav-link"
            [class]="{'active': info.active }"
            [id]="info.id + '-tab'"
            data-toggle="tab"
            [attr.href]="'#'+ info.id"
            role="tab"
            [attr.aria-controls]="info.id"
            aria-selected="true"
            (click)="selectInfo(info)">
              {{info.title | translate }}
          </a>
        </li>
      </ul>
      <div class="tab-content" id="myTabContent">
        <div
          class="tab-pane fade show py-3"
          [id]="infosActive.id"
          [class]="{'active': infosActive.active}"
          role="tabpanel"
          [attr.aria-controls]="infosActive.id + '-tab'">{{ infosActive.descr | translate }}</div>
      </div>
    </div>
    <button
      class="btn py-3 mx-5 my-3"
      [class]="infoCard.disabled ? 'btn-outline-danger' : 'btn-primary'"
      type="submit" (click)="handlerInfoCard( infoCard.disabled, infoCard.title, infoCard.path )">{{ infoCard.disabled ? 'Attivalo adesso' : infoCard.title | translate  }}
    </button>
  </div>
</div>
